import { styled } from 'styled-components';

export const SideInfoContainer = styled.div`
  /* width: 300px;
  height: 100%;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* position: fixed; 
  top: 0;
  box-sizing: content-box;
  background: #fff;
  z-index: 60;
  margin-top: 24px; */
`;

export const SideInfoWrap = styled.div`
  gap: 16px;
`;

export const Box = styled.div`
  /* width: 100%;
  padding: 16px 24px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid var(--Alias-Color-Text-Dark-Text-Disabled, #171e2666);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between; */
`;

export const Box2 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;

export const BorderButton = styled.button<{
  color?: string;
  number?: number;
  link?: string;
}>`
  cursor: pointer;
  width: calc((100% - 16px) / ${(props) => props.number || 3});
  padding: 4px 0;
  gap: 2px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.color || '#171e2666'};
  display: flex;
  justify-content: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  line-height: 17.4px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${(props) => props.color || '#171e26'};
  &:hover {
    background: ${(props) => props.color};
    color: ${(props) => (props.color ? '#FFFFFF' : '')};
  }
  // cursor: ${(props) => (props.link ? 'pointer' : 'not-allowed')};
  pointer-events: ${(props) => (props.link ? 'auto' : 'none')};
`;

export const BorderButton2 = styled.button`
  cursor: pointer;
  gap: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 11px;
  font-weight: 500;
  line-height: 15.95px;
  letter-spacing: -0.02em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--Alias-Color-Text-Dark-Text-Primary, #171e26);
`;

export const BorderButton2Circle = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 999px;
  border: 0.88px solid #171e2666;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const CommonButton = styled.button<{ width?: number }>`
  width: ${(props) => props.width}px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const CommonRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ColorTitle = styled.div<{ color: string }>`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  line-height: 17.4px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${(props) => props.color};
`;

export const CommonTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  line-height: 23.2px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const CommonButton2 = styled.button<{ color: string }>`
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 8px 16px;
  gap: 2px;
  border-radius: 6px;
  background: ${(props) => props.color};
  justify-content: center;

  //styleName: Spoqa/Body/12_Bold;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 700;
  line-height: 17.4px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--Alias-Color-Text-Nav-Background-Default, #ffffff);
  border: 1px solid ${(props) => props.color};

  &:hover {
    background: #00000000;
    color: ${(props) => props.color};
    img {
      filter: invert(43%) sepia(82%) saturate(3455%) hue-rotate(359deg)
        brightness(100%) contrast(106%);
    }
  }
`;

export const SWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 8px;
  border-block: 1px solid var(--Alias-Color-Text-White-BlueGray-600, #5e7188);
  margin-bottom: 50px;
`;

export const SItem = styled.button`
  cursor: pointer;
  width: 100%;
  padding: 8px 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  line-height: 17.4px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #171e268f;
`;